import { httpApi } from './http';

const api = httpApi;

export interface StatsCountsRequest {
  startDate?: string;
  endDate?: string;
  models?: string[];
}

export interface ModelCountData {
  count: number;
  dateFieldUsed: string;
}

export interface StatsCountsResponse {
  success: boolean;
  dateRange?: {
    startDate?: string;
    endDate?: string;
  };
  models?: string[];
  counts: {
    [modelName: string]: ModelCountData;
  };
}

export class StatsService {
  static async getCounts(params: StatsCountsRequest = {}): Promise<StatsCountsResponse> {
    try {
      const response = await api.post<StatsCountsResponse>('/stats/counts', {
        startDate: params.startDate,
        endDate: params.endDate,
        models: params.models,
      });

      const payload = response.data;
      if (!payload) throw new Error('No data received from server');
      if (payload.success === false) {
        throw new Error('API request failed');
      }

      return payload;
    } catch (error: any) {
      if (error.response?.data?.error) {
        throw new Error(error.response.data.error);
      }
      throw new Error('Failed to fetch stats');
    }
  }
}
